import React from 'react';
import { Copy, Title } from '#components/atoms';

export const TermsAndCondPromotions: React.FC = () => {
  return (
    <div className="mb-20">
      <div className="lg:flex lg:flex-col lg:items-center overflow-hidden px-5 py-12">
        <Title className="m-4 mt-24  flex text-center text-3xl lg:!text-5xl lg:col-span-full lg:col-start-5 2xl:!text-6xl">
          TÉRMINOS Y CONDICIONES <br /> CAMPAÑA “DÍAS CALIENTES” DE BILOG SRL
        </Title>
      </div>
      <Copy className="m-5 md:mx-24 !font-bold !text-xl">1. ALCANCE</Copy>
      <Copy className="m-5 md:mx-24">
        La presente campaña promocional, en adelante “Días Calientes”, es
        organizada por Bilog SRL, empresa desarrolladora de software de gestión
        (SaaS) para clínicas y consultorios odontológicos, con sede legal en la
        República Argentina y operaciones activas en Uruguay, Colombia, Ecuador
        y Venezuela.
        <br /> <br />
        La campaña se desarrollará entre el día 14 de mayo de 2025 a las 00:00
        hs y el día 16 de mayo de 2025 a las 23:59 hs, considerando el huso
        horario local de cada país en donde opera Bilog. La empresa se reserva
        el derecho de extender dicha vigencia por un plazo adicional de hasta
        siete (7) días, lo cual será informado oportunamente a través de los
        canales oficiales de comunicación.
        <br /> <br />
        Este documento está redactado en idioma español. En caso de existir
        discrepancias con versiones traducidas, prevalecerá la versión original
        en español.
      </Copy>
      <Copy className="m-5 md:mx-24 !font-bold !text-xl">
        2. DESCARGO DE RESPONSABILIDAD SOBRE MARCAS
      </Copy>
      <Copy className="m-5 md:mx-24">
        La campaña “Días Calientes” no está asociada ni vinculada con marcas
        registradas, eventos ni entidades de terceros, incluyendo pero no
        limitándose a la marca “Hot Sale” y la Cámara Argentina de Comercio
        Electrónico (CACE). Bilog SRL no ha abonado licencias ni ha solicitado
        autorizaciones para el uso de ninguna marca registrada ajena a su
        titularidad. Toda similitud con expresiones comerciales o promocionales
        de terceros es meramente coincidente y no intencional.
      </Copy>
      <Copy className="m-5 md:mx-24 !font-bold !text-xl">
        3. BENEFICIOS DE LA CAMPAÑA
      </Copy>
      <Copy className="m-5 md:mx-24">
        Las promociones incluidas en la campaña estarán disponibles únicamente
        para usuarios registrados en la plataforma de Bilog, conforme su tipo de
        plan y país de residencia.
        <br /> <br />
        Los usuarios con plan Free, en todos los países, podrán acceder a una
        suscripción Premium con el primer mes gratuito. Los usuarios con planes
        Premium, Full y Standard en Argentina podrán acceder al Pack de Recetas
        e Imágenes con un 50% de descuento durante tres (3) meses. Los usuarios
        Small y Small Premium en Argentina podrán realizar un upgrade de plan
        (Small a Standard o Small Premium a Full) e incluir en ese cambio el
        Pack de Imágenes y Recetas con el primer mes gratis. Finalmente, los
        usuarios Premium de Uruguay, Colombia, Ecuador y Venezuela podrán
        acceder al Pack de Imágenes con un 50% de descuento por tres (3) meses.
        <br /> <br />
        La activación de cualquier beneficio se realizará mediante aceptación
        explícita en la plataforma. El usuario podrá cancelar la suscripción o
        dar de baja el beneficio en cualquier momento, sin compromisos de
        permanencia.
      </Copy>
      <Copy className="m-5 md:mx-24 !font-bold !text-xl">
        4. CONDICIONES GENERALES
      </Copy>
      <Copy className="m-5 md:mx-24">
        Las promociones ofrecidas en el marco de “Días Calientes” no son
        acumulables con otras ofertas, descuentos o cupones vigentes.
        <br /> <br />
        Una vez finalizado el período promocional, los servicios contratados se
        renovarán automáticamente al precio regular vigente, salvo que el
        usuario haya gestionado la cancelación previa desde su panel de control.
        <br /> <br /> La cancelación de la suscripción deberá realizarse con una
        antelación mínima de veinticuatro (24) horas respecto del vencimiento
        del período vigente, a fin de evitar la renovación automática. Si el
        usuario no gestionara la baja dentro de este plazo, se entenderá válida
        y aceptada la renovación del servicio bajo las condiciones normales de
        contratación vigentes al momento de la renovación.
        <br /> <br />
        La baja anticipada del servicio no implicará penalización alguna.
        <br /> <br /> En caso de upgrades de plan, los usuarios podrán revertir
        el cambio en cualquier momento durante el período de beneficio. Las
        combinaciones habilitadas incluyen: de Free a Premium, de Small a
        Standard, de Small Premium a Full y de Standard a Full.
        <br /> <br />
        Los servicios complementarios que Bilog ofrece por fuera de la
        suscripción mensual no están incluidos dentro de la campaña, salvo
        mención expresa. Dichos servicios incluyen integraciones con terceros,
        desarrollos personalizados, y soporte técnico premium. Para más
        información, se invita al usuario a consultar la sección correspondiente
        en la plataforma.
      </Copy>
      <Copy className="m-5 md:mx-24 !font-bold !text-xl">
        5. CONDICIONES DE VIGENCIA Y CONTRATACIÓN
      </Copy>
      <Copy className="m-5 md:mx-24">
        Los beneficios serán aplicables únicamente para contrataciones iniciadas
        entre el 14 y el 16 de mayo de 2025. Si el pago se efectúa con
        posterioridad, el beneficio será respetado siempre que el acuerdo haya
        sido generado y publicado dentro del período oficial de la campaña.
        <br /> <br />A efectos probatorios, se considerará válida la fecha y
        hora registrada por los servidores de Bilog al momento de la activación
        del beneficio.
      </Copy>
      <Copy className="m-5 md:mx-24 !font-bold !text-xl">
        6. EXCLUSIONES Y LIMITACIONES
      </Copy>
      <Copy className="m-5 md:mx-24">
        Toda comunicación referida a la campaña será realizada a través de los
        canales oficiales de Bilog, incluyendo su plataforma SaaS, sitio web
        institucional y redes sociales.
        <br /> <br />
        En caso de existir contradicciones entre lo comunicado por estos medios
        y el presente documento, prevalecerá lo aquí establecido.
        <br /> <br /> Si por error técnico, humano o tipográfico se publicara un
        beneficio, precio o condición incorrecta, Bilog se reserva el derecho de
        corregir dicha información sin obligación de respetarla ni generar
        indemnizaciones o resarcimientos.
        <br /> <br />
        Bilog no se hace responsable por fallas de conectividad, rechazos de
        pago, inactividad de sistemas o cualquier otro factor técnico o externo
        que impida al usuario contratar o utilizar correctamente los beneficios
        promocionales.
      </Copy>
      <Copy className="m-5 md:mx-24 !font-bold !text-xl">
        7. DERECHO A MODIFICACIÓN O CANCELACIÓN
      </Copy>
      <Copy className="m-5 md:mx-24">
        Bilog podrá, por decisión propia o ante situaciones de fuerza mayor,
        modificar, suspender o cancelar total o parcialmente la campaña “Días
        Calientes” sin que esto genere derecho a reclamos por parte de los
        usuarios. No obstante, los beneficios ya activados se mantendrán
        vigentes hasta cumplir su ciclo correspondiente, salvo en los casos
        excepcionales mencionados.
      </Copy>
      <Copy className="m-5 md:mx-24 !font-bold !text-xl">
        8. LEY APLICABLE Y JURISDICCIÓN
      </Copy>
      <Copy className="m-5 md:mx-24">
        Estos términos se rigen por las leyes de la República Argentina. Ante
        cualquier controversia derivada de su interpretación, validez o
        cumplimiento, serán competentes los tribunales ordinarios de la Ciudad
        Autónoma de Buenos Aires, con renuncia expresa a cualquier otro fuero.
        <br /> <br />
        En los países donde la legislación local no permita dicha renuncia, esta
        cláusula se considerará inaplicable en la medida en que así lo determine
        la normativa vigente.
      </Copy>
      <Copy className="m-5 md:mx-24 !font-bold !text-xl">
        9. ACEPTACIÓN DE TÉRMINOS
      </Copy>
      <Copy className="m-5 md:mx-24">
        La participación en la campaña implica la aceptación expresa, total e
        irrevocable de los presentes Términos y Condiciones. El usuario que no
        acepte estos términos deberá abstenerse de activar promociones o
        contratar servicios dentro del período de vigencia.
      </Copy>
    </div>
  );
};
